import { OrganizationUser } from '../UsersSlice'
import { AdminRole } from '../type/AdminRole'
import { PrescriberClient } from '../../../pages/NewScriptPage/ScriptForm/PrescriberSlice'
import { OrganizationAdminClient } from '../../organization-admin/organizationAdminSlice'
import { areStringArraysEqual } from '../../../utils/array/areStringArraysEqual'
import { convertRoleToPermissions } from './AdminPermissions'

export const syncPrescriberRole = async (
  user: OrganizationUser,
  organizationId: string,
  shouldBePrescriber: boolean
): Promise<void> => {
  const profile = user.prescriber
  const isActive = !!profile?.active

  if (!profile && shouldBePrescriber) {
    await PrescriberClient.createSimpleProfile({
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      organizationId,
      userId: user.userId,
    })
    return
  }

  if (profile && !isActive && shouldBePrescriber) {
    await PrescriberClient.updateActiveStatus({
      prescriberId: profile.id,
      active: true,
    })
    return
  }

  if (profile && isActive && !shouldBePrescriber) {
    await PrescriberClient.updateActiveStatus({
      prescriberId: profile.id,
      active: false,
    })
  }
}

export const syncAdminRole = async (
  user: OrganizationUser,
  organizationId: string,
  targetRole: AdminRole
): Promise<void> => {
  const profile = user.admin

  if (profile?.isOwner) {
    return
  }

  const isActive = !!profile?.active
  const targetPermissions = convertRoleToPermissions(targetRole)
  const existingPermissions = profile?.permissions ?? []
  const permissionsChanged = !areStringArraysEqual(existingPermissions, targetPermissions)

  if (!profile && targetRole) {
    await OrganizationAdminClient.createAdminProfile({
      familyName: user.lastName,
      givenName: user.firstName,
      userId: user.userId,
      email: user.email,
      permissions: targetPermissions,
      organizationId,
    })
    return
  }

  if (profile && !isActive && targetRole) {
    await OrganizationAdminClient.updateActiveStatus({
      adminId: profile.id,
      active: true,
    })
    if (permissionsChanged) {
      await OrganizationAdminClient.updateAdminPermissions({
        adminId: profile.id,
        permissions: targetPermissions,
      })
    }
    return
  }

  if (profile && isActive && !targetRole) {
    await OrganizationAdminClient.updateActiveStatus({
      adminId: profile.id,
      active: false,
    })
    return
  }

  if (profile && isActive && targetRole && permissionsChanged) {
    await OrganizationAdminClient.updateAdminPermissions({
      adminId: profile.id,
      permissions: targetPermissions,
    })
  }
}
